import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDv6gjN7b55O_kglANLYiD0QPOuW635hnk",
  authDomain: "til-map.firebaseapp.com",
  projectId: "til-map",
  storageBucket: "til-map.appspot.com",
  messagingSenderId: "899728505421",
  appId: "1:899728505421:web:be979d685f02f066897a04"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export {db}